var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2644 4.69678H2.01565C1.45472 4.69678 1 5.14188 1 5.69095V20.0058C1 20.5549 1.45472 21 2.01565 21H12.2644C12.8254 21 13.2801 20.5549 13.2801 20.0058V5.69095C13.2801 5.14188 12.8254 4.69678 12.2644 4.69678Z",
    stroke: "#352890",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95508 2.36152V1.99417C4.95508 1.44606 5.41078 1 5.97072 1H16.2225C16.7824 1 17.2381 1.44606 17.2381 1.99417V16.312C17.2381 16.8601 16.7824 17.3062 16.2225 17.3062H15.46",
    stroke: "#352890",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.2bc2d04ef869bd3aa25611e8fddb2ea4.svg";
export { ForwardRef as ReactComponent };